import { AppLayout } from "@bcc/components/app-layout";
import { DemoDataTag } from "@bcc/components/tour/demo-data/demo-data-tag";
import { useDemoPayoutContext } from "@bcc/components/tour/demo-data/use-demo-invoices";
import { FinanceInvoicesView } from "@bcc/components/views/finance-invoices-view";
import type { InvoiceFilters } from "@bcc/lib/types/invoice";
import { PayoutContext } from "@client-shared/providers/payout";

export function FinanceInvoicesPage() {
  const initialFilters: InvoiceFilters = {};
  // While the tour runs, the view reads sample invoices from a nested payout context instead of the roaster's
  const demoPayout = useDemoPayoutContext();
  const view = <FinanceInvoicesView initialFilters={initialFilters} />;

  return (
    <AppLayout>
      <DemoDataTag />
      {demoPayout ? <PayoutContext.Provider value={demoPayout}>{view}</PayoutContext.Provider> : view}
    </AppLayout>
  );
}
